import React from "react";
import api from "@/lib/api";
import PageHeader from "@/components/PageHeader";
import { TelecallerSheet } from "@/components/telecaller/TelecallerSheet";

export default function Telecaller() {
  return (
    <div>
      <PageHeader eyebrow="Office" title="Telecaller Sheet" subtitle="Call, WhatsApp and follow up leads — office staff & company only" />
      <div className="p-4 sm:p-8">
        <TelecallerSheet client={api} token={localStorage.getItem("token")} />
      </div>
    </div>
  );
}
